var render = function render(){var _vm=this,_c=_vm._self._c;return _c('element-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"is-full-page":"","color":"#4F71C3","loading":_vm.loading,"z-index":9999}})
}
var staticRenderFns = []

export { render, staticRenderFns }